import React from "react";
import "../assets/scss/RedirectPage.scss";
export const RedirectPage: React.FC = () => {
  return (
    <div className="container min-h-screen flex justify-center items-center ">
      <div className="image h-20 w-20 mx-auto my-auto"></div>
    </div>
  );
};
